<template>
  <div v-show="$store.state.message.visible">
    <el-badge :value="$store.state.message.unread" :is-dot="$store.state.message.unread === 0 " :max="99" style="line-height: 30px;margin-top: -5px;">
      <el-button size="small" class="btn" type="primary" icon="el-icon-message-solid" @click="showDetail" />
    </el-badge>
  </div>
</template>

<script>
export default {
  name: 'MessageBadge',
  data() {
    return {
      time: 60000
    }
  },
  created() {
    this.getNewMessage()
    let timer = setInterval(this.getNewMessage, this.time)
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
      timer = null
    })
  },
  methods: {
    showDetail() {
      const code = this.$store.state.user.code
      if (code) {
        this.$router.push({ path: `/project/${code}/iot/center-data/warning` })
      } else {
        this.$router.push({ path: '/iot/center-data/warning' })
      }
    },
    getNewMessage() {
      this.$store.dispatch('message/setState')
    }
  }
}
</script>

<style scoped>
.btn {
  padding:0;
  font-size: 18px;
}
</style>
